import ODataUtil from "./ODataUtil";
import { deleteItem, patchItem, postItem, ApiRequest } from './ApiUtils';
import Visitor from 'classes/Visitor';
import buildQuery from 'odata-query';

const visitorEndpoint = "/Visitor";

/**
 * Get visitors with OData query support
 */
async function getVisitors(page, per_page, orderByInfo, orderByDirection, search, filters) {
  try {
    const { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
      per_page, page, Visitor.expand, orderByInfo, orderByDirection, filters
    );
    const filter = {};
    const isDefaults = filters.find(r => r.defaults);

    if (isDefaults) {
      const defaults = isDefaults.defaults;
      if(defaults.projectId) filter["ihwi/workItem/projectId"] = { eq: { type: 'guid', value: defaults.projectId }};
      if(defaults.inspectionNumber) filter["ihwi/inspection/inspectionNumber"] = defaults.inspectionNumber;
    }

    const allFilters = mappedFilter.reduce((a, b) => ({...a, ...b}), filter);
    const params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });

    const data = await ApiRequest(visitorEndpoint, params);
    return Visitor.convertToTableRows(data);
  } catch (error) {
    console.error('Error fetching visitors:', error);
    throw error;
  }
}

/**
 * Add a new visitor
 */
async function addVisitor(data) {
  try {
    const resourcePath = `${visitorEndpoint}/Add`;
    const result = await postItem(resourcePath, '', data);
    return result;
  } catch (error) {
    console.error('Error adding visitor:', error);
    throw error;
  }
}

/**
 * Update an existing visitor
 */
async function updateVisitor(visitId, data) {
  try {
    const resourcePath = `${visitorEndpoint}/Update`;
    const params = `?visitId=${visitId}`;
    const result = await patchItem(resourcePath, params, data);
    return result;
  } catch (error) {
    console.error('Error updating visitor:', error);
    throw error;
  }
}

/**
 * Delete a visitor
 */
async function deleteVisitor(visitId) {
  try {
    const resourcePath = `${visitorEndpoint}/Delete`;
    const params = `?visitId=${visitId}`;
    const result = await deleteItem(resourcePath, params);
    return result;
  } catch (error) {
    console.error('Error deleting visitor:', error);
    throw error;
  }
}

/**
 * Get a specific visitor by ID
 */
async function getVisitorById(visitId) {
  try {
    const expand = Visitor.expand;
    const { expand: expandQuery } = ODataUtil.UtilityBuilderNestedv3(
      1,
      0,
      expand,
      null,
      null,
      []
    );

    const params = buildQuery({
      expand: expandQuery,
      filter: { VisitId: { eq: { type: 'guid', value: visitId } } }
    });

    const response = await fetch(`${visitorEndpoint}${params}`);
    const result = await response.json();

    if (result.value && result.value.length > 0) {
      return new Visitor(result.value[0]);
    }

    return null;
  } catch (error) {
    console.error('Error fetching visitor by ID:', error);
    throw error;
  }
}

export {
  getVisitors,
  addVisitor,
  updateVisitor,
  deleteVisitor,
  getVisitorById
};
